import { render, staticRenderFns } from "./LocationEditor.vue?vue&type=template&id=48967bea&"
import script from "./LocationEditor.vue?vue&type=script&lang=js&"
export * from "./LocationEditor.vue?vue&type=script&lang=js&"
import style0 from "./LocationEditor.vue?vue&type=style&index=0&id=48967bea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports